document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('digb-range-tonne-set');
  const jsonUrl = container.getAttribute('data-json-url');

  fetch(jsonUrl)
    .then(response => response.json())
    .then(data => {
      // Clear the container
      container.innerHTML = '';

      // Get the current excavator parameter from URL
      const urlParams = new URLSearchParams(window.location.search);
      let currentExcavator = urlParams.get('excavator');
      
      // Set default excavator if none is present
      if (!currentExcavator) {
        currentExcavator = 'tonnes_2-0_3-2_mini';
        
        // Update the URL to include the default parameter
        const url = new URL(window.location);
        url.searchParams.set('excavator', currentExcavator);
        history.replaceState({}, '', url);
      }

      // Create a container for the grid
      const gridContainer = document.createElement('div');
      gridContainer.className = 'digb-range-tonne-grid';
      
      // Process each item in the JSON data
      data.forEach(item => {
        // Only use 'image' and 'link' fields as specified
        const image = item.image;
        const link = item.link;
        const key = item.key || '';

        if (image && link) {
          // Create a link element
          const linkElement = document.createElement('a');
          
          // Check if this item is the currently selected excavator
          if (currentExcavator && key.includes(currentExcavator)) {
            linkElement.classList.add('active-tonne');
          }
          
          // Set the excavator key as a data attribute for handling clicks
          linkElement.setAttribute('data-excavator', key);
          
          // Prevent default navigation behavior and handle with AJAX
          linkElement.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Update the URL using history.pushState
            const url = new URL(window.location);
            url.searchParams.set('excavator', key);
            
            // Update the active state visually
            document.querySelectorAll('.digb-range-tonne-grid a').forEach(el => {
              el.classList.remove('active-tonne');
            });
            this.classList.add('active-tonne');
            
            // Update the browser history without page refresh
            history.pushState({}, '', url);
            
            // Here you would normally trigger loading the product section based on the selection
            // For now, we can just update a placeholder or trigger an event
            console.log('Selected excavator:', key);
            
            // You can trigger an event to load products based on the selection
            const event = new CustomEvent('excavatorSelected', { detail: { excavator: key } });
            document.dispatchEvent(event);
          });
          
          // Create an image element
          const imgElement = document.createElement('img');
          imgElement.src = image;
          imgElement.alt = item.title || ''; // Use title as alt text if available
          imgElement.loading = 'lazy'; // For performance
          
          // Append image to link
          linkElement.appendChild(imgElement);
          
          // Append link to grid container
          gridContainer.appendChild(linkElement);
        }
      });
      
      // Append the grid to the main container
      container.appendChild(gridContainer);
    })
    .catch(error => {
      console.error('Error loading digb-range-tonne-set data:', error);
    });
});